module.exports = __webpack_public_path__ + "static/media/Intro-Y-A.9b208b07.mp3";